import { Box, Typography, Grid, TextField, Paper } from "@material-ui/core"
import { WarningOutlined } from "@material-ui/icons";
import { makeStyles } from '@material-ui/core/styles';
import { Theme, createStyles } from '@material-ui/core/styles';
import { PortalBannerMessages } from "@roc/feature-app-core";
import { useStore } from "@roc/client-portal-shared/hooks";
import { sanitizeHtml } from '@roc/ui/utils';

const useStyle = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(4),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    backgroundColor: '#FEF0ED',
    color: '#642B20',
  },
  content: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(1),
  },
  icon: {
    color: theme.palette.warning.light,
  }
}));

export const DisclaimerMessage = () => {
  const classes = useStyle();
  const { globalStore } = useStore();
  const { routeBaseUrl } = globalStore;

    const bannerMessages: Array<PortalBannerMessages> = [
      {
        title: "Disclosure",
        content: "Payment for the appraisal does not guarantee loan approval or a specific loan amount. The completed appraisal will be submitted to the lender for review, and will be released after full review. The lender reserves the right to adjust loan terms, including reducing the loan amount, based on their own internal valuation assessment and underwriting guidelines."
      }
    ];

  let messageComponents = [];
  messageComponents = bannerMessages && bannerMessages.map(message => {
    const content: string = message.content.replace(':portal-base-url', routeBaseUrl);

    return (
      <Grid container className={classes.content} spacing={2}>
        <Grid item>
          <WarningOutlined className={classes.icon} />
        </Grid>
        <Grid item xs={11}>
          <Typography gutterBottom>
            <strong>

              {'Disclaimer'}
            </strong>
            <br />
            <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }}></div>

          </Typography>
        </Grid>
      </Grid >
    );
  }


  );
  return (
    <>
      {bannerMessages?.length > 0 ? (
        <>
          <Paper className={classes.paper} title="">
            {messageComponents}
          </Paper>
          <br />
        </>) : null
      }
    </>
    );
}